var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "6 6 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user_svg__a_OS619Z74{fill:currentColor}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "user_svg__a_OS619Z74",
    d: "M22 37.998a16.393 16.393 0 0 1-7.785-1.828C11.786 34.92 9.66 33.084 8 30.802c.07-4.447 9.333-6.882 14-6.882 4.65 0 13.929 2.435 14 6.882-1.659 2.282-3.786 4.12-6.215 5.368A16.393 16.393 0 0 1 22 37.998ZM22.609 21.36c4.034 0 7.304-3.438 7.304-7.68 0-4.242-3.27-7.68-7.304-7.68-4.035 0-7.305 3.438-7.305 7.68 0 4.242 3.27 7.68 7.305 7.68Z",
    fill: "#030D0F"
  })));
};
export default SvgUser;